import { useMutation } from '@tanstack/react-query';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { generateEnrollmentTicket } from '../../../common/api/clients/mfa.api';
import { translate } from '../../../common/helpers/translate.helper';

export const useEnrollmentTicketGenerate = () => {
    const { addErrorToast } = useToasts();

    return useMutation({
        mutationFn: () => generateEnrollmentTicket(),
        onError: () => {
            addErrorToast(translate('mfa.error.enrollmentFailed'));
        },
    });
};
